import { DotFitter } from '@sc/data-access-models';

export class DotFittersAddedAction {
  static readonly type = '[DotFitters] Added';
  constructor(public dotFitters: DotFitter[], public merge = true) {}
}

export class DotFittersClearedAction {
  static readonly type = '[DotFitters] Cleared';
}

export class DotFittersShowMoreAction {
  static readonly type = '[DotFitters] Show More';
}
